import { ConfigurationMetaValidationError } from "./errors";
/**
 * Compiles a variable's `pattern` into a whole-value matcher. Anchoring here
 * (rather than expecting the author to write ^...$) is what makes "matches the
 * pattern" mean the same thing for every variable -- an unanchored source
 * would otherwise silently accept any value merely *containing* a match.
 */
export function compileConfigValuePattern(pattern) {
    try {
        return new RegExp(`^(?:${pattern})$`);
    }
    catch {
        throw new ConfigurationMetaValidationError(`"${pattern}" is not a valid regular expression`);
    }
}
//# sourceMappingURL=configurationMetaValidation.js.map